/* Rheinkauf – Bestellstatus, Rücksendung und „Benachrichtigen, wenn wieder da“.
   Spricht mit dem Rheinkauf-Worker (Cloudflare), gleiche API wie bei WSTND:
     GET  /api/track?no=&email=&lang=de[&scope=return]
     POST /api/returns
     POST /api/notify
   Die Worker-Adresse steht an genau einer Stelle: snippets/rk-api.liquid
   (landet hier als data-rk-api am jeweiligen Block).
   Aufbau 24.09.2026: Suchformular klappt nach dem Treffer zu einer Zeile zusammen,
   Rücksendung in nummerierten Schritten, Bestellstatus mit Fortschrittsbalken. */
(function () {
  'use strict';

  var LANG = 'de';

  /* ---------- Helfer ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function datum(iso) {
    if (!iso) return '';
    try {
      return new Date(iso).toLocaleDateString('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric' });
    } catch (e) { return ''; }
  }
  function datumKurz(iso) {
    if (!iso) return '';
    try { return new Date(iso).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' }); } catch (e) { return ''; }
  }
  function datumZeit(iso) {
    if (!iso) return '';
    try {
      return new Date(iso).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
    } catch (e) { return ''; }
  }
  function eur(n) {
    return Number(n || 0).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }
  function api(base, path) { return String(base || '').replace(/\/+$/, '') + path; }

  var ICON = {
    haken: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    paket: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3.5 7.5 12 3l8.5 4.5v9L12 21l-8.5-4.5v-9Z M3.5 7.5 12 12l8.5-4.5 M12 12v9" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
    lkw: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 6.5h11v9h-11z M13.5 9.5h4l3 3v3h-7 M6.5 18.5a1.7 1.7 0 1 0 0-.1 M17 18.5a1.7 1.7 0 1 0 0-.1" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
    drucker: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.5 9V3.5h11V9 M6.5 17H4a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-2.5 M6.5 14h11v6.5h-11z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
    doku: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 3h8l4 4v14H6z M14 3v4h4 M9 12h6 M9 16h6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
    qr: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 4h6v6H4z M14 4h6v6h-6z M4 14h6v6H4z M14 14h2v2h-2z M18 14h2 M14 18h2v2 M18 18h2v2h-2" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>',
    info: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M12 11v5.5 M12 7.6v.1" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>'
  };

  function fehlerText(code) {
    switch (code) {
      case 'not_found': return 'Wir finden keine Bestellung zu dieser Kombination. Bitte prüfen Sie Bestellnummer und E-Mail-Adresse – so, wie sie in der Bestellbestätigung stehen.';
      case 'rate_limited': return 'Zu viele Anfragen in kurzer Zeit. Bitte versuchen Sie es in ein paar Minuten noch einmal.';
      case 'not_delivered': return 'Die Bestellung ist noch nicht zugestellt. Eine Rücksendung können Sie anmelden, sobald das Paket bei Ihnen ist.';
      case 'window_expired': return 'Die Rückgabefrist für diese Bestellung ist abgelaufen. Bei einem Defekt melden Sie sich bitte über die Kontaktseite – dann gilt die Gewährleistung.';
      case 'return_open': return 'Für diese Bestellung ist bereits eine Rücksendung angemeldet.';
      case 'qty_invalid': return 'Bitte wählen Sie mindestens einen Artikel aus.';
      case 'reason_invalid': return 'Bitte wählen Sie für jeden Artikel einen Grund.';
      case 'too_many': return 'Mit dieser Adresse sind schon sehr viele Artikel vorgemerkt.';
      case 'disabled': return 'Die Benachrichtigung ist gerade nicht verfügbar. Bitte versuchen Sie es später noch einmal.';
      case 'bad_request': return 'Bitte prüfen Sie Ihre Eingaben.';
      default: return 'Das hat gerade nicht geklappt. Bitte versuchen Sie es gleich noch einmal oder schreiben Sie uns über die Kontaktseite.';
    }
  }

  async function holen(url, opts) {
    var res, body = null;
    try {
      res = await fetch(url, opts);
    } catch (e) {
      return { ok: false, error: 'network' };
    }
    try { body = await res.json(); } catch (e) { body = null; }
    if (!res.ok) return { ok: false, status: res.status, error: (body && body.error) || 'server_error' };
    return { ok: true, status: res.status, data: body };
  }

  /* ---------- Suchformular: nach Treffer zu einer Zeile einklappen ---------- */
  function suchleiste(root, no, email) {
    var form = $('form', root);
    var bar = $('[data-rk-bar]', root);
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'rk-bar';
      bar.setAttribute('data-rk-bar', '');
      form.parentNode.insertBefore(bar, form.nextSibling);
    }
    bar.innerHTML = '<span class="rk-bar__icon">' + ICON.paket + '</span>' +
      '<span class="rk-bar__text"><strong>Bestellung ' + esc(no) + '</strong><span>' + esc(email) + '</span></span>' +
      '<button type="button" class="rk-bar__btn">Ändern</button>';
    bar.hidden = false;
    form.hidden = true;
    var intro = $('[data-rk-intro]', root); if (intro) intro.hidden = true;
    $('button', bar).onclick = function () {
      bar.hidden = true; form.hidden = false;
      if (intro) intro.hidden = false;
      $('[data-rk-out]', root).innerHTML = '';
      schritt(root, 1);
      form.elements.no.focus();
    };
  }

  function schritt(root, n) {
    $$('[data-rk-schritt]', root).forEach(function (li) {
      var k = parseInt(li.getAttribute('data-rk-schritt'), 10);
      li.classList.toggle('is-fertig', k < n || (n === 4 && k === 4));
      li.classList.toggle('is-aktiv', k === n && n !== 4);
      if (k === n) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current');
    });
  }

  function fehlerBox(text) {
    return '<div class="rk-fehler" role="alert"><span class="rk-fehler__icon">' + ICON.info + '</span><p>' + esc(text) + '</p></div>';
  }

  /* ---------- Texte für Status-Codes (Worker liefert nur Codes) ---------- */
  var STATUS = {
    storniert: ['Storniert', 'rk-st--grau'],
    bearbeitung: ['In Bearbeitung', 'rk-st--gelb'],
    unterwegs: ['Unterwegs', 'rk-st--blau'],
    teilweise: ['Teilweise versandt', 'rk-st--blau'],
    verzoegert: ['Verzögert', 'rk-st--rot'],
    zugestellt: ['Zugestellt', 'rk-st--gruen']
  };

  function etaText(eta) {
    if (!eta) return '';
    var d = datum(eta.dueAt);
    switch (eta.code) {
      case 'cancelled': return 'Diese Bestellung wurde storniert.';
      case 'delivered_one_at': return 'Zugestellt am ' + d;
      case 'delivered_all_at': return 'Alle Pakete zugestellt, zuletzt am ' + d;
      case 'delivered_one': return 'Ihr Paket wurde zugestellt';
      case 'delivered_all': return 'Alle Pakete wurden zugestellt';
      case 'stuck_some': return 'Paket ' + (eta.packets || []).join(', ') + ' hat seit längerem keinen neuen Scan';
      case 'stuck_all': return 'Ihre Sendung hat seit längerem keinen neuen Scan';
      case 'due_one': return 'Voraussichtlich am ' + d + ' bei Ihnen';
      case 'due_first': return 'Erstes Paket voraussichtlich am ' + d;
      case 'ship_soon': return 'Wir packen Ihre Bestellung';
      case 'deliver_soon': return 'Ihr Paket ist unterwegs';
      default: return '';
    }
  }
  function etaZusatz(eta) {
    if (!eta) return '';
    switch (eta.code) {
      case 'stuck_some':
      case 'stuck_all': return 'Wir haken beim Versender nach – melden Sie sich gern, falls es eilt.';
      case 'ship_soon': return 'Sobald das Paket unterwegs ist, bekommen Sie eine E-Mail mit der Sendungsnummer.';
      case 'deliver_soon': return 'Es kommt in den nächsten Tagen.';
      default: return '';
    }
  }

  var SCHRITT = {
    packed: 'Im Lager gepackt',
    handover: 'An {carrier} übergeben',
    handover_generic: 'An den Versender übergeben',
    accepted: 'Vom Versender übernommen',
    hub_origin: 'Im Start-Paketzentrum',
    hub: 'Im Paketzentrum',
    hub_dest: 'Im Ziel-Paketzentrum',
    customs: 'Zollabfertigung',
    arrived_country: 'Im Zielland angekommen',
    out_for_delivery: 'In Zustellung',
    failed: 'Zustellung nicht möglich',
    failed_attempt: 'Zustellung nicht möglich',
    attempt_failed: 'Zustellung nicht möglich',
    pickup_branch: 'Zur Abholung in der Filiale',
    packstation: 'In der Packstation',
    neighbour: 'Beim Nachbarn abgegeben',
    returning: 'Auf dem Rückweg zu uns',
    delivered: 'Zugestellt',
    update: 'Neue Meldung vom Versender',
    rma_registered: 'Rücksendung angemeldet',
    rma_shipped: 'Paket an uns unterwegs',
    rma_arrived: 'Bei uns eingetroffen',
    rma_checked: 'Geprüft',
    rma_refunded: 'Erstattet'
  };
  function schrittText(st) {
    if (st.c === 'other' && st.raw) return st.raw;
    var t = SCHRITT[st.c];
    if (!t) {
      if (/^hub/.test(st.c)) t = 'Im Paketzentrum';
      else if (/fail|attempt/.test(st.c)) t = 'Zustellung nicht möglich';
      else t = 'Neue Meldung vom Versender';
    }
    return t.replace('{carrier}', st.carrier || 'den Versender');
  }

  function bild(it, gr) {
    gr = gr || 56;
    return it.image
      ? '<img class="rk-bild" src="' + esc(it.image) + '" alt="" width="' + gr + '" height="' + gr + '" loading="lazy">'
      : '<span class="rk-bild rk-bild--leer" aria-hidden="true">' + ICON.paket + '</span>';
  }
  function variante(it) {
    return it.variant && it.variant !== 'Default Title' ? '<span class="rk-art__zusatz">' + esc(it.variant) + '</span>' : '';
  }

  function artikelListe(items) {
    return '<ul class="rk-art">' + (items || []).map(function (it) {
      return '<li>' + bild(it) +
        '<span class="rk-art__text"><span class="rk-art__name">' + esc(it.name) + '</span>' + variante(it) +
        '<span class="rk-art__zusatz">Menge: ' + esc(it.qty) + '</span></span></li>';
    }).join('') + '</ul>';
  }

  function zeitleiste(steps) {
    var liste = steps || [];
    /* Eingeklappt: nur die letzten zwei erledigten Schritte vor dem aktuellen + den Rest zeigen */
    var aktuell = -1;
    liste.forEach(function (st, i) { if (st.s === 'current' || st.s === 'problem' || st.s === 'done') aktuell = i; });
    var ab = Math.max(0, aktuell - 2);
    var viele = ab > 0;
    var h = '<ol class="rk-zeit' + (viele ? ' rk-zeit--kurz' : '') + '">' + liste.map(function (st, i) {
      return '<li class="rk-zeit__s rk-zeit__s--' + esc(st.s || 'pending') + (i < ab ? ' rk-zeit__s--alt' : '') + '">' +
        '<span class="rk-zeit__punkt" aria-hidden="true"></span>' +
        '<span class="rk-zeit__t">' + esc(schrittText(st)) + '</span>' +
        (st.at ? '<span class="rk-zeit__d">' + esc(datumZeit(st.at)) + '</span>' : '') +
        '</li>';
    }).join('') + '</ol>';
    if (viele) h += '<button type="button" class="rk-link" data-rk-mehr>Frühere Schritte anzeigen (' + ab + ')</button>';
    return h;
  }
  function zeitleisteBinden(root) {
    $$('[data-rk-mehr]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var ol = b.previousElementSibling;
        var alt = ol.querySelectorAll('.rk-zeit__s--alt').length;
        var kurz = ol.classList.toggle('rk-zeit--kurz');
        b.textContent = kurz ? 'Frühere Schritte anzeigen (' + alt + ')' : 'Weniger anzeigen';
      });
    });
  }

  /* ---------- Bestellstatus ---------- */
  function initTrack(root) {
    var form = $('form', root);
    var out = $('[data-rk-out]', root);
    var base = root.getAttribute('data-rk-api');

    var q = new URLSearchParams(location.search);
    if (q.get('no')) form.elements.no.value = q.get('no');
    if (q.get('email')) form.elements.email.value = q.get('email');

    async function suchen() {
      var no = form.elements.no.value.trim();
      var email = form.elements.email.value.trim();
      var feh = $('[data-rk-formfehler]', form);
      if (!no || !email) { feh.innerHTML = fehlerBox('Bitte Bestellnummer und E-Mail-Adresse eingeben.'); return; }
      feh.innerHTML = '';
      var btn = $('button[type=submit]', form);
      btn.disabled = true; btn.textContent = 'Wird gesucht …';
      out.innerHTML = '';
      var r = await holen(api(base, '/api/track') + '?no=' + encodeURIComponent(no) + '&email=' + encodeURIComponent(email) + '&lang=' + LANG);
      btn.disabled = false; btn.textContent = 'Bestellung suchen';
      if (!r.ok) { feh.innerHTML = fehlerBox(fehlerText(r.error)); return; }
      suchleiste(root, r.data.id || no, email);
      out.innerHTML = renderTrack(r.data, no, email);
      zeitleisteBinden(out);
      root.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }

    form.addEventListener('submit', function (e) { e.preventDefault(); suchen(); });
    if (q.get('no') && q.get('email')) suchen();
  }

  function stufe(d) {
    if (d.state === 'storniert') return 0;
    if (d.state === 'zugestellt') return 4;
    if (d.state === 'bearbeitung') return 1;
    var zustellung = (d.shipments || []).some(function (s) {
      return (s.steps || []).some(function (st) { return st.c === 'out_for_delivery' && st.s === 'current'; });
    });
    return zustellung ? 3 : 2;
  }

  function fortschritt(n, problem) {
    var namen = ['Bestellt', 'Versandt', 'In Zustellung', 'Zugestellt'];
    return '<ol class="rk-fort' + (problem ? ' rk-fort--problem' : '') + '" aria-label="Fortschritt">' + namen.map(function (t, i) {
      var k = i + 1;
      var cls = k < n || (k === n && n === 4) ? 'is-fertig' : (k === n ? 'is-aktiv' : '');
      if (n === 1 && k === 1) cls = 'is-fertig';
      return '<li class="' + cls + '"' + (k === n ? ' aria-current="step"' : '') + '><span class="rk-fort__balken"></span><span class="rk-fort__t">' + t + '</span></li>';
    }).join('') + '</ol>';
  }

  function renderTrack(d, no, email) {
    var st = STATUS[d.state] || ['Status', 'rk-st--grau'];
    var n = stufe(d);
    var h = '<section class="rk-karte rk-karte--status">' +
      '<div class="rk-kopf"><p class="rk-klein">Bestellt am ' + esc(datumKurz(d.placedAt)) + '</p>' +
      '<span class="rk-st ' + st[1] + '">' + esc(st[0]) + '</span></div>' +
      '<h2 class="rk-h2">' + esc(etaText(d.eta)) + '</h2>' +
      (etaZusatz(d.eta) ? '<p class="rk-text">' + esc(etaZusatz(d.eta)) + '</p>' : '') +
      (n ? fortschritt(n, d.state === 'verzoegert') : '') +
      '</section>';

    (d.shipments || []).forEach(function (s) {
      h += '<section class="rk-karte">' +
        '<div class="rk-kopf"><h3 class="rk-h3">' + ICON.lkw +
        ((d.shipments.length > 1) ? 'Paket ' + esc(s.nr) : 'Ihre Sendung') + (s.carrier ? ' · ' + esc(s.carrier) : '') + '</h3>' +
        (s.dueAt && d.shipments.length > 1 ? '<span class="rk-klein">Voraussichtlich ' + esc(datumKurz(s.dueAt)) + '</span>' : '') + '</div>' +
        (s.tracking ? '<p class="rk-sendnr">Sendungsnummer <strong>' + esc(s.tracking) + '</strong>' +
          (s.trackUrl ? ' <a class="rk-link" href="' + esc(s.trackUrl) + '" target="_blank" rel="noopener">Beim Versender ansehen ›</a>' : '') + '</p>' : '') +
        zeitleiste(s.steps) +
        '<div class="rk-trenner"></div>' + artikelListe(s.items) +
        '</section>';
    });

    if (d.open && d.open.length) {
      h += '<section class="rk-karte"><h3 class="rk-h3">' + ICON.paket + 'Noch nicht versandt</h3>' + artikelListe(d.open) + '</section>';
    }

    var unten = '';
    if (d.shipTo && d.shipTo.length) {
      unten += '<div><h3 class="rk-h4">Lieferadresse</h3><p class="rk-text">' + d.shipTo.map(esc).join('<br>') + '</p></div>';
    }
    if (d.deliveredAt) {
      unten += '<div><h3 class="rk-h4">Rückgabe</h3>' + (d.returnOpen
        ? '<p class="rk-text">Möglich bis ' + esc(datumKurz(d.returnUntil)) + '.</p><a class="rk-btn rk-btn--hell rk-btn--klein" href="/pages/ruecksendung?no=' + encodeURIComponent(no) + '&email=' + encodeURIComponent(email) + '">Rücksendung anmelden</a>'
        : '<p class="rk-text">Die Frist von ' + esc(d.returnDays) + ' Tagen ist abgelaufen. Bei einem Defekt helfen wir trotzdem: <a class="rk-link" href="/pages/beratung-und-kontakt">Kontakt</a></p>') + '</div>';
    }
    if (unten) h += '<section class="rk-karte rk-karte--spalten">' + unten + '</section>';
    return h;
  }

  /* ---------- Rücksendung ---------- */
  var GRUENDE = [
    ['gefaellt_nicht', 'Gefällt mir nicht / anders überlegt'],
    ['passt_nicht', 'Entspricht nicht der Beschreibung'],
    ['defekt', 'Beschädigt oder defekt'],
    ['falsch', 'Falscher Artikel geliefert'],
    ['anderer', 'Anderer Grund']
  ];
  var KOSTENLOS = ['defekt', 'falsch'];

  function initReturn(root) {
    var form = $('form', root);
    var out = $('[data-rk-out]', root);
    var base = root.getAttribute('data-rk-api');
    var preis = parseFloat(root.getAttribute('data-rk-label-preis') || '0') || 0;
    var stand = null;

    var q = new URLSearchParams(location.search);
    if (q.get('no')) form.elements.no.value = q.get('no');
    if (q.get('email')) form.elements.email.value = q.get('email');
    schritt(root, 1);

    async function suchen() {
      var no = form.elements.no.value.trim();
      var email = form.elements.email.value.trim();
      var feh = $('[data-rk-formfehler]', form);
      if (!no || !email) { feh.innerHTML = fehlerBox('Bitte Bestellnummer und E-Mail-Adresse eingeben.'); return; }
      feh.innerHTML = '';
      var btn = $('button[type=submit]', form);
      btn.disabled = true; btn.textContent = 'Wird gesucht …';
      out.innerHTML = '';
      var r = await holen(api(base, '/api/track') + '?no=' + encodeURIComponent(no) + '&email=' + encodeURIComponent(email) + '&lang=' + LANG + '&scope=return');
      btn.disabled = false; btn.textContent = 'Weiter';
      if (!r.ok) { feh.innerHTML = fehlerBox(fehlerText(r.error)); return; }
      stand = { no: no, email: email, d: r.data };
      suchleiste(root, r.data.id || no, email);
      out.innerHTML = renderReturn(r.data, preis);
      schritt(root, r.data.openReturn ? 4 : 2);
      bindReturn(root, out, base, preis, stand);
      zeitleisteBinden(out);
      root.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }

    form.addEventListener('submit', function (e) { e.preventDefault(); suchen(); });
    if (q.get('no') && q.get('email')) suchen();
  }

  function belege(o) {
    var h = '<div class="rk-belege">';
    if (o.labelUrl) h += '<a class="rk-beleg rk-beleg--haupt" href="' + esc(o.labelUrl) + '" target="_blank" rel="noopener">' + ICON.drucker + '<span><strong>DHL-Retourenlabel</strong><small>PDF zum Ausdrucken</small></span></a>';
    if (o.qrUrl) h += '<a class="rk-beleg" href="' + esc(o.qrUrl) + '" target="_blank" rel="noopener">' + ICON.qr + '<span><strong>QR-Code</strong><small>Ohne Drucker: in der DHL-Filiale zeigen</small></span></a>';
    if (o.slipUrl) h += '<a class="rk-beleg" href="' + esc(o.slipUrl) + '" target="_blank" rel="noopener">' + ICON.doku + '<span><strong>Retourenschein</strong><small>PDF – gehört ins Paket</small></span></a>';
    return h + '</div>';
  }

  function naechsteSchritte(mitLabel) {
    var s = mitLabel
      ? ['Retourenschein ausdrucken und ins Paket legen.', 'DHL-Label aufs Paket kleben – oder den QR-Code in der Filiale zeigen, dort wird das Label gedruckt.', 'Paket bei DHL abgeben. Nach der Prüfung erstatten wir auf Ihr ursprüngliches Zahlungsmittel.']
      : ['Retourenschein ausdrucken und ins Paket legen – nur so können wir es Ihrer Bestellung zuordnen.', 'Paket selbst frankieren. Die Anschrift steht auf dem Retourenschein.', 'Paket abgeben. Nach der Prüfung erstatten wir auf Ihr ursprüngliches Zahlungsmittel.'];
    return '<ol class="rk-naechste">' + s.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ol>';
  }

  function erfolg(rma, extra, o, mitLabel, zeit) {
    return '<section class="rk-karte rk-karte--erfolg">' +
      '<span class="rk-erfolg__icon">' + ICON.haken + '</span>' +
      '<p class="rk-klein">Rücksendenummer</p>' +
      '<h2 class="rk-h2 rk-rma">' + esc(rma) + '</h2>' +
      (extra || '') +
      '</section>' +
      '<section class="rk-karte"><h3 class="rk-h3">Ihre Unterlagen</h3>' + belege(o) + '</section>' +
      '<section class="rk-karte"><h3 class="rk-h3">So geht es weiter</h3>' + naechsteSchritte(mitLabel) + (zeit || '') + '</section>';
  }

  function renderReturn(d, preis) {
    if (d.openReturn) {
      var o = d.openReturn;
      return erfolg(o.rma,
        '<p class="rk-text">Bereits angemeldet am ' + esc(datumKurz(o.createdAt)) + (o.shipmentNo ? ' · DHL-Sendungsnummer ' + esc(o.shipmentNo) : '') + '.</p>',
        o, !!o.labelUrl,
        (o.steps && o.steps.length ? '<div class="rk-trenner"></div><h3 class="rk-h4">Stand Ihrer Rücksendung</h3>' + zeitleiste(o.steps) : ''));
    }
    if (d.block === 'unterwegs') {
      return '<section class="rk-karte"><h2 class="rk-h2">Ihr Paket ist noch unterwegs</h2>' +
        '<p class="rk-text">Eine Rücksendung können Sie anmelden, sobald es bei Ihnen angekommen ist. Die Frist beginnt erst mit der Zustellung.</p>' +
        '<a class="rk-btn rk-btn--hell" href="/pages/bestellung-verfolgen?no=' + encodeURIComponent(d.id) + '">Sendung verfolgen</a></section>';
    }
    if (d.block === 'frist') {
      return '<section class="rk-karte"><h2 class="rk-h2">Die Rückgabefrist ist abgelaufen</h2>' +
        '<p class="rk-text">Zugestellt am ' + esc(datumKurz(d.deliveredAt)) + ', die Frist beträgt ' + esc(d.returnDays) + ' Tage. Bei einem Defekt gilt die gesetzliche Gewährleistung.</p>' +
        '<a class="rk-btn rk-btn--hell" href="/pages/beratung-und-kontakt">Kontakt aufnehmen</a></section>';
    }

    var zeilen = (d.items || []).map(function (it, i) {
      var max = Number(it.qty || 1);
      var mengeFeld = '';
      if (max > 1) {
        var opts = '';
        for (var n = 1; n <= max; n++) opts += '<option value="' + n + '">' + n + ' von ' + max + '</option>';
        mengeFeld = '<label class="rk-feld rk-feld--menge"><span>Menge</span><select name="qty-' + i + '">' + opts + '</select></label>';
      } else {
        mengeFeld = '<input type="hidden" name="qty-' + i + '" value="1">';
      }
      return '<li class="rk-wahl" data-i="' + i + '">' +
        '<label class="rk-wahl__kopf">' +
        '<input type="checkbox" class="rk-wahl__check" name="pick-' + i + '">' +
        '<span class="rk-wahl__box" aria-hidden="true">' + ICON.haken + '</span>' +
        bild(it, 64) +
        '<span class="rk-art__text"><span class="rk-art__name">' + esc(it.name) + '</span>' + variante(it) +
        '<span class="rk-art__zusatz">' + esc(eur(it.price)) + (max > 1 ? ' · ' + max + ' Stück bestellt' : '') + '</span></span>' +
        '</label>' +
        '<div class="rk-wahl__mehr" hidden>' + mengeFeld +
        '<fieldset class="rk-gruende"><legend>Warum senden Sie zurück?</legend>' +
        GRUENDE.map(function (g) {
          return '<label class="rk-grund"><input type="radio" name="reason-' + i + '" value="' + g[0] + '"><span>' + esc(g[1]) + '</span></label>';
        }).join('') + '</fieldset>' +
        '<details class="rk-notiz"><summary>Anmerkung hinzufügen (optional)</summary><textarea name="note-' + i + '" maxlength="300" rows="2" placeholder="z. B. was genau defekt ist"></textarea></details>' +
        '</div></li>';
    }).join('');

    var weg = d.labelAvailable
      ? '<div class="rk-wege">' +
        '<label class="rk-weg"><input type="radio" name="method" value="label" checked><span class="rk-weg__inhalt">' + ICON.drucker +
        '<span><strong>DHL-Retourenlabel von uns</strong><small>Label kommt sofort als PDF und QR-Code</small></span>' +
        '<span class="rk-weg__preis" data-rk-labelpreis>' + (preis > 0 ? esc(eur(preis)) : 'kostenlos') + '</span></span></label>' +
        '<label class="rk-weg"><input type="radio" name="method" value="selbst"><span class="rk-weg__inhalt">' + ICON.paket +
        '<span><strong>Ich frankiere selbst</strong><small>Mit einem Versender Ihrer Wahl</small></span>' +
        '<span class="rk-weg__preis">0,00 €</span></span></label>' +
        '</div>' +
        (preis > 0 ? '<p class="rk-hinweis">' + ICON.info + '<span>Bei defekter oder falscher Ware ist das Label kostenlos.</span></p>' : '')
      : '<p class="rk-hinweis">' + ICON.info + '<span>Sie senden das Paket selbst frankiert an uns zurück. Die Anschrift steht auf dem Retourenschein.</span></p>';

    return '<form data-rk-ret novalidate>' +
      '<section class="rk-karte">' +
      '<div class="rk-kopf"><h2 class="rk-h2 rk-h2--nr"><span class="rk-nr">2</span>Artikel auswählen</h2>' +
      '<span class="rk-frist">Noch ' + esc(d.daysLeft) + ' Tage Rückgabe</span></div>' +
      '<ul class="rk-wahlliste">' + zeilen + '</ul></section>' +
      '<section class="rk-karte" data-rk-teil3>' +
      '<h2 class="rk-h2 rk-h2--nr"><span class="rk-nr">3</span>Versandart</h2>' + weg + '</section>' +
      '<section class="rk-karte rk-karte--summe">' +
      '<dl class="rk-summe" data-rk-summe></dl>' +
      '<div data-rk-fehler></div>' +
      '<button class="rk-btn rk-btn--voll" type="submit">Rücksendung verbindlich anmelden</button>' +
      '<p class="rk-klein rk-zentriert">Label und Retourenschein bekommen Sie sofort hier und per E-Mail.</p>' +
      '</section></form>';
  }

  function bindReturn(root, out, base, preis, stand) {
    var f = $('form[data-rk-ret]', out);
    if (!f) return;
    var items = stand.d.items || [];
    var fehler = $('[data-rk-fehler]', f);
    var summe = $('[data-rk-summe]', f);

    /* Nur ein Artikel? Dann gleich vorauswählen. */
    if (items.length === 1) { var c = f.elements['pick-0']; if (c) c.checked = true; }

    function auswahl() {
      var sel = {}, waren = 0, frei = false, anzahl = 0, ohneGrund = false;
      items.forEach(function (it, i) {
        if (!f.elements['pick-' + i].checked) return;
        var qty = parseInt(f.elements['qty-' + i].value, 10) || 1;
        var r = f.querySelector('input[name="reason-' + i + '"]:checked');
        var reason = r ? r.value : '';
        if (!reason) ohneGrund = true;
        sel[it.sku] = { qty: qty, reason: reason, note: (f.elements['note-' + i].value || '').slice(0, 300) };
        waren += Number(it.price || 0) * qty;
        if (KOSTENLOS.indexOf(reason) !== -1) frei = true;
        anzahl++;
      });
      var m = f.querySelector('input[name=method]:checked');
      var method = m ? m.value : 'selbst';
      var gebuehr = (!frei && method === 'label') ? preis : 0;
      return { sel: sel, anzahl: anzahl, waren: waren, gebuehr: gebuehr, frei: frei, method: method, ohneGrund: ohneGrund };
    }

    function aktualisieren() {
      $$('.rk-wahl', f).forEach(function (li) {
        var an = $('.rk-wahl__check', li).checked;
        li.classList.toggle('is-gewaehlt', an);
        $('.rk-wahl__mehr', li).hidden = !an;
      });
      var a = auswahl();
      var lp = $('[data-rk-labelpreis]', f);
      if (lp && preis > 0) lp.innerHTML = a.frei ? '<s>' + esc(eur(preis)) + '</s> kostenlos' : esc(eur(preis));
      schritt(root, a.anzahl ? (a.ohneGrund ? 2 : 3) : 2);
      summe.innerHTML = a.anzahl
        ? '<div><dt>Warenwert (' + a.anzahl + (a.anzahl === 1 ? ' Artikel' : ' Artikel') + ')</dt><dd>' + esc(eur(a.waren)) + '</dd></div>' +
          (a.method === 'label' ? '<div><dt>DHL-Retourenlabel</dt><dd>' + (a.gebuehr ? '− ' + esc(eur(a.gebuehr)) : 'kostenlos') + '</dd></div>' : '') +
          '<div class="rk-summe__gesamt"><dt>Ihre Erstattung</dt><dd>' + esc(eur(Math.max(0, a.waren - a.gebuehr))) + '</dd></div>'
        : '<div class="rk-summe__leer"><dt>Noch kein Artikel ausgewählt</dt><dd></dd></div>';
    }
    f.addEventListener('change', aktualisieren);
    aktualisieren();

    f.addEventListener('submit', async function (e) {
      e.preventDefault();
      fehler.innerHTML = '';
      var a = auswahl();
      if (!a.anzahl) { fehler.innerHTML = fehlerBox(fehlerText('qty_invalid')); return; }
      if (a.ohneGrund) { fehler.innerHTML = fehlerBox(fehlerText('reason_invalid')); return; }

      var btn = $('button[type=submit]', f);
      btn.disabled = true; btn.textContent = 'Wird angemeldet …';
      var r = await holen(api(base, '/api/returns'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ order: stand.no, email: stand.email, method: a.method, payout: 'erstattung', items: a.sel, lang: LANG })
      });
      if (!r.ok) {
        btn.disabled = false; btn.textContent = 'Rücksendung verbindlich anmelden';
        fehler.innerHTML = fehlerBox(fehlerText(r.error)); return;
      }
      var d = r.data;
      var ohneLabel = a.method === 'label' && !d.labelUrl;
      schritt(root, 4);
      out.innerHTML = erfolg(d.rma,
        '<p class="rk-text">Ihre Rücksendung ist angemeldet.' + (d.notified ? ' Die Unterlagen haben wir Ihnen zusätzlich per E-Mail geschickt.' : '') + '</p>' +
        (ohneLabel ? '<p class="rk-hinweis rk-hinweis--gelb">' + ICON.info + '<span>Das DHL-Label konnte gerade nicht erstellt werden. Bitte frankieren Sie selbst – die Kosten ziehen wir nicht ab. Oder schreiben Sie uns, dann schicken wir das Label nach.</span></p>' : ''),
        d, !!d.labelUrl, '');
      root.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
  }

  /* ---------- Benachrichtigen, wenn wieder da ---------- */
  function initNotify(root) {
    var base = root.getAttribute('data-rk-api');
    var daten = {};
    try { daten = JSON.parse($('script[type="application/json"]', root).textContent); } catch (e) {}
    var form = $('form', root);
    var ok = $('[data-rk-ok]', root);
    var fehler = $('[data-rk-fehler]', root);
    var aktuell = null;

    function varianteJetzt() {
      var feld = document.querySelector('form[action*="/cart/add"] [name="id"]');
      var id = (feld && feld.value) || new URLSearchParams(location.search).get('variant') || daten.first;
      return String(id || '');
    }
    function pruefen() {
      var id = varianteJetzt();
      if (id === aktuell) return;
      aktuell = id;
      var verfuegbar = daten.v ? daten.v[id] : true;
      root.hidden = verfuegbar !== false;
      ok.hidden = true; form.hidden = false; fehler.hidden = true;
    }
    document.addEventListener('change', function () { setTimeout(pruefen, 50); });
    window.addEventListener('popstate', pruefen);
    setInterval(pruefen, 800); /* Varianten-Picker schreiben die ID nicht immer mit Event */
    pruefen();

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      fehler.hidden = true;
      var email = form.elements.email.value.trim();
      if (!email) return;
      var btn = $('button', form);
      btn.disabled = true;
      var r = await holen(api(base, '/api/notify'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ variantId: aktuell, email: email, lang: LANG })
      });
      btn.disabled = false;
      if (!r.ok) { fehler.textContent = fehlerText(r.error); fehler.hidden = false; return; }
      if (r.data && r.data.available) { location.reload(); return; }
      form.hidden = true; ok.hidden = false;
    });
  }

  function start() {
    document.querySelectorAll('[data-rk-track]').forEach(initTrack);
    document.querySelectorAll('[data-rk-return]').forEach(initReturn);
    document.querySelectorAll('[data-rk-notify]').forEach(initNotify);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
